/**
 * Single Supabase client for the entire portal.
 *
 * Always import from here — never call createClient elsewhere. Keeps auth
 * state and connection pooling consistent across pages and components.
 *
 * Env vars (set in .env.local locally, Vercel project settings in prod):
 *   VITE_SUPABASE_URL       — public project URL
 *   VITE_SUPABASE_ANON_KEY  — public anon key (RLS-gated, safe in browser)
 *
 * Never put SUPABASE_SERVICE_ROLE_KEY anywhere VITE_-prefixed — it would
 * ship to the browser. That key only ever runs in scripts/migrations.
 */

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY ' +
    'in .env.local (dev) or Vercel project settings (production).'
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
